// extracted by mini-css-extract-plugin
export var container = "blogposts-module--container--7ba23";
export var wrapper = "blogposts-module--wrapper--a5257";